import { restClient } from '../../client';


type ForgotPasswordOutput = {
  status: string;
  error?: string;
};


export const forgotPassword = (email: string) => {
  return restClient.request<ForgotPasswordOutput>(
    '/auth/reset_password',
    {
      method: 'POST',
      data: {
        email: email
      }
    }
  );
};
